var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33 17.058c-.346 0-.676-.14-.912-.388L.339 10.29c-.474-.495-.447-1.275.055-1.74.504-.466 1.295-.442 1.766.053l5.157 5.41 10.51-11.336c.467-.504 1.257-.537 1.767-.079.509.458.544 1.238.079 1.74L8.252 16.655c-.234.254-.567.4-.914.402h-.009z",
    transform: "translate(-490 -481) translate(490 481)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledTick);
export default __webpack_public_path__ + "static/media/icon-filled-tick.b551e0eddba44daa92500d942134ca37.svg";
export { ForwardRef as ReactComponent };